import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Checkbox,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { AddBox, ExpandMore } from "@mui/icons-material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  MoneyFormatv2,
  MoneyFormatv3,
  NewMoneyFormatv2,
} from "../../../library/MoneyFormat";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import DeleteEntries from "../../../components/modals/DeleteEntries";
import PercentIcon from "@mui/icons-material/Percent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import theme from "../../../styles/Themecolors";
import { grey } from "@mui/material/colors";
import CreatePriceType from "./CreatePriceType";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "2px solid rgba(224, 224, 224, 1)",
      borderBottom: "2px solid rgba(224, 224, 224, 1)",
    },
  },
  newTableCell: {
    "& .MuiTableCell-root": {
      borderTop: "3px solid #9b6ab7 !important", // Top border
      borderBottom: "3px solid #9b6ab7", // Bottom border
      borderLeft: "3px solid #9b6ab7", // Left border
      borderRight: "3px solid #9b6ab7", // Right border
    },
  },
  stickyCell: {
    position: "sticky",
    right: 0,
    minWidth: "70px",
    backgroundColor: theme.palette.bodyGray.secondary,
    zIndex: 10, // Ensure the sticky cell appears above other cells
    boxShadow: "-5px 0 0 0 red", // Simulate a left border with shadow
    outline: "none",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      width: "1px", // Adjust this value for the desired border thickness
      backgroundColor: "rgba(224, 224, 224, 1)", // Border color
      zIndex: 11, // Ensure it appears above the cell content
      outline: "none",
    },
    "&:focus": {
      outline: "none", // This will remove the outline on focus
    },
  },
  focusTableCell: {
    // "&:focus-within": {
    //   borderTop: "5px solid  #1d79ff  !important", // Top border
    //   borderBottom: "5px solid  #1d79ff  !important", // Bottom border
    //   borderLeft: "5px solid  #1d79ff  !important", // Left border
    //   borderRight: "5px solid  #1d79ff  !important", // Right border
    // },
    // backgroundColor: theme?.palette?.TmId.id.toString().includes("9") ? "#cccc8c" : "#FFFF99"
  },
});

function NewDynamicEntryTable({
  Type,
  tableType,
  from,
  rows,
  tempRow,
  editedRow,
  setRows,
  setEditedRow,
  setTempRow,
  data,
  companyData,
  registrationType,
  endDate,
  startDate,
  // //NewDynamicEntryTable,
  newItemRowStatus,
  setIsFocusItem,
  isFocusItem,
  rowIndex,
  setRowIndex,
  deleteEntriesModal,
  setDeleteEntriesModal,
  entryIndex,
  setEntryIndex,
  todayDate,
  setAmtExcGst,
  setAmtIncGst,
  amountExcGst,
  amountIncGst,
  GStRates,
  CessTypes,
  DiscountType,
  setEffectiveToFlag,
  effectiveToFlag,
  taxableValue,
  editFlag,
  setEditFlag,
  isFocusRow,
  setIsFocusRow,
  isValid,
  setIsValid,
  PriceTypes,
  isDuplicate,
  setIsDuplicate,
  isActive,
  setIsActive,
  invDate,
  itemUsed,
  activeFlag,
  focusCell,
  setFocusCell,
  params,
  openAccordan,
  setOpenAccordan,
  priceTypeArr,
  setPriceTypeArr,
  priceTypeID,
  setPriceTypeID,
  setUpdatedPrice,
  newArr,
  emptyPriceType,
  setEmptyPriceType,
  nameObj,
  setTableErrArr,
}) {
  const classes = useStyles();

  let sampleHeader = [
    { id: "SL.No", label: "SL.No", width: "100px" },
    { id: "Name", label: "Name", width: "100px" },
    { id: "Amount", label: "Amount", width: "100px" },
    { id: "Action", label: "Action", width: "100px" },
  ];
  const [tableArr, setTableArr] = useState([
    {
      name: "",
      amount: 0,
    },
  ]);
  const inputRef = useRef(null);
  const [maxDate, setMaxDate] = useState("");
  const [maxToDate, setMaxTodate] = useState("");
  const [minDate, setMinDate] = useState("");
  const [focusTableCell, setFocusTableCell] = useState(false);
  const [openPriceModal, setOpenPriceModal] = useState(false);

  const [successSnackbar, setsuccessSnakbar] = useState([]);

  function saveChangesInRows(rows) {
    let isvalid = true;
    let editedobj = rows;
    let requireds = [];
    if (editedobj?.name === "") {
      requireds.push("Name");
      isvalid = false;
    }
    if (editedobj?.amount === "" || editedobj?.amount === 0) {
      requireds.push("Amount");
      isvalid = false;
    }
    const hasEmptyFields = tableArr.some(
      (row) => row.name === "" || row.amount === "" || row.amount === 0
    );
    let newObj = {
      name: "",
      amount: 0,
    };
    if (isvalid) {
      let arr = [];
      if (!hasEmptyFields) {
        arr = [newObj, ...tableArr];
      } else {
        arr = [...tableArr];
      }
      setTableArr(arr);
    } else {
      if (requireds.length > 0) {
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + " " + "is required");
        } else {
          showWarningSnackbar(`${requireds}` + " " + "are required");
        }
      }
    }
  }

  function closeChangesInRows(ind) {
    let arr = [...tableArr].filter((item, index) => {
      if (ind != index) {
        return item;
      }
    });
    setTableArr(arr);
  }

  return (
    <>
      <Box
        className="PageHeight"
        sx={{
          padding: {
            xs: "80px 20px 20px 20px",
            sm: "70px 30px 20px 80px",
          },
          m: 1,
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            marginBottom: "10px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
            ".MuiTableCell-root": {
              padding: "0px 5px",
            },
            ".MuiTableCell-head": {
              borderBottom: "0px",
              fontWeight: "bold",
            },
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow className={classes.table}>
                  {sampleHeader.map((ele) => {
                    return <TableCell width={ele.width}>{ele.label}</TableCell>;
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableArr?.map((col, ind) => {
                  return (
                    <TableRow key={ind} className={classes.table}>
                      <TableCell>{ind + 1}</TableCell>
                      <TableCell>
                        <TextField
                          name="name"
                          id="name"
                          value={col.name}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Create a copy of the array and update the specific item
                            const updatedTableArr = [...tableArr];
                            updatedTableArr[ind] = {
                              ...updatedTableArr[ind],
                              name: value,
                            };
                            setTableArr(updatedTableArr); // Make sure to have setTableArr function to update the state
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              const updatedTableArr = [...tableArr];
                              saveChangesInRows(updatedTableArr[ind]);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="amount"
                          id="amount"
                          value={col.amount}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Create a copy of the array and update the specific item
                            const updatedTableArr = [...tableArr];
                            updatedTableArr[ind] = {
                              ...updatedTableArr[ind],
                              amount: value,
                            };
                            setTableArr(updatedTableArr); // Make sure to have setTableArr function to update the state
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              const updatedTableArr = [...tableArr];
                              saveChangesInRows(updatedTableArr[ind]);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton
                          tabIndex="0"
                          id={ind}
                          disableRipple
                          aria-label="delete"
                          sx={{
                            margin: "0px 2px",
                            padding: "5px",
                            backgroundColor:
                              col?.new === true ? "#fbc7c7" : "#83ff7b7a",
                          }}
                          onClick={(e) => {
                            closeChangesInRows(ind);
                          }}
                        >
                          <CloseIcon
                            sx={{
                              fontSize: "18px",
                              color: "#eb6a6a",
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
}

export default NewDynamicEntryTable;
